import { Component, inject } from '@angular/core';
import { ToastService } from '../../../core/services/toast-service';

@Component({
  selector: 'app-toasts',
  template: `
		@for (toast of toastService.toasts; track toast) {
			<ngb-toast
				[class]="toast.mode"
				[autohide]="true"
				[delay]="toast.delay"
				(hidden)="toastService.remove(toast)"
			>
      {{toast.message}}
			</ngb-toast>
		}
	`,
  host: { class: 'toast-container position-fixed bottom-0 start-50 translate-middle-x p-3', style: 'z-index: 1200' },
})
export class ToastsContainer {
  toastService = inject(ToastService);
}
